// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__VrF9x"};